import LogisticsPage from "./logistics.page"

export default LogisticsPage;
